<template>
  <div class="navi_content">
    <!-- 导航栏 -->
    <div class="basic_menu_core" :class="{basic_menu:isindex!=0,basic_header_none:indexheight<=800}">
      <div class="logo pointer" @click="jump"></div>
      <div class="nav" ref="navRef">
        <div class="nav-item" @mouseenter="isShow = false" @click="updateCss('1')" :class="{to_active:shows==1}" :v-model="shows"><router-link to="/home">首页</router-link></div>
        <div class="nav-item" @mouseenter="isShow = false" @click="updateCss('2')" :class="{to_active:shows==2}" :v-model="shows"><router-link to="/home">行业资讯</router-link></div>
        <div class="nav-item" @mouseenter="isShow = false" @click="updateCss('3')" value = "3" :class="{to_active:shows==3}" :v-model="shows"><router-link to="/price">价格行情</router-link></div>
        <div class="nav-item" @mouseenter="isShow = false" @click="updateCss('4')" value = "4":class="{to_active:shows==4}" :v-model="shows"><router-link to="/home">数据中心</router-link></div>
        <div class="nav-item" @mouseenter="showDropDown('5')"  :class="{to_active:shows==5}" :v-model="shows"><router-link to="/home">知识库</router-link></div>
      </div>
    </div>
      <!-- 下拉菜单 -->
      <transition name="dropdown">
        <div v-show="isShow" class="dropdown-content" @mouseleave="hideDropDown">
          <div class="dropdown-menu">
              <div class="menuItem" v-for="(item, index) in analog" :key="index"  :v-model="parentval" @click="updateParentCss(parentval)">
                <router-link :to=item.to_url>
                  <div class="menuImg">
                    <img :src="item.imgUrl"/>
                  </div>
                  <div class="menuText">
                    {{ item.text }}
                  </div>
                </router-link>
              </div>
          </div>
        </div>
      </transition>
  </div>
</template>

<script>
export default {
  name: "navi",
  data() {
    return {
      isShow: false,
      navTop: 0,
      // 模拟下拉菜单内容
      analog: [],
      shows: this.isindex,
      parentval: 0,
      indexheight: this.height,
    };
  },
  props: ['height','isindex'],
  watch: {
    height(newVal, oldVal) {
      if(newVal){
        this.indexheight= newVal;
        return this.indexheight
      }
    }
  },
  mounted() {
    // 导航栏距页面高度 = 元素顶部距页面距离 + 元素本身高度
    this.navTop =
      this.$refs.navRef.getBoundingClientRect().top +
      this.$refs.navRef.offsetHeight;
  },
  methods: {
    jump() {
      window.open("https://www.repe.com.cn/");
    },
    showDropDown(val) {
      if (!this.isShow) {
        this.isShow = true;
      }
      if (val === "5") {
        this.analog = [
          {
            text: '政策',
            imgUrl: require('../assets/img/index/zhengce.png'),
            to_url: '/policy',
          },
          {
            text: '企业',
            imgUrl: require('../assets/img/index/qiye.png'),
            to_url: '/home',
          },
          {
            text: '研究机构',
            imgUrl: require('../assets/img/index/jigou.png'),
            to_url: '/home',
          },
          {
            text: '产品',
            imgUrl: require('../assets/img/index/chanpin.png'),
            to_url: '/home',
          },
          {
            text: '科研成果',
            imgUrl: require('../assets/img/index/keyanchengguo.png'),
            to_url: '/ScientificResearch',
          },
          {
            text: '项目',
            imgUrl: require('../assets/img/index/zhuanli.png'),
            to_url: '/project',
          },
          {
            text: '标准',
            imgUrl: require('../assets/img/index/biaozhun.png'),
            to_url: '/standard',
          },
          {
            text: '矿产资源',
            imgUrl: require('../assets/img/index/kuangchanziyuan.png'),
            to_url: '/minerals',
          },
        ];
      }
      // else if(val === "3"){
      //   this.analog = [
      //     {
      //       text: '菜单31',
      //       imgUrl: require('../assets/img/index/qiye.png'),
      //       to_url: '/home',
      //     },
      //     {
      //       text: '菜单32',
      //       imgUrl: require('../assets/img/index/qiye.png'),
      //       to_url: '/home',
      //     },
      //     {
      //       text: '菜单33',
      //       imgUrl: require('../assets/img/index/qiye.png'),
      //       to_url: '/home',
      //     },
      //   ];
      // }
      this.parentval = val;
      return this.parentval;
    },
    updateCss(val) {
      this.shows = val;
      return this.shows;
    },
    updateParentCss(pra_val,) {
      this.shows = pra_val;
      return this.shows;
    },
    hideDropDown(e) {
      // e.pageY：鼠标指针相对页面的偏移量
      if (this.isShow && e.pageY >= this.navTop) this.isShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/css/header.css";
.dropdown-enter-active {
  animation: expand-contract 0.8s ease;
}
.dropdown-leave-active {
  animation: expand-contract 0.8s ease reverse;
}
.to_active{
  color: #ff9d00;
  font-weight: bolder;
  border-bottom: #ff9d00 3px solid;
}


// 下拉菜单收缩展开
@keyframes expand-contract {
  0% {
    opacity: 0;
    height: 0;
    // max-height: 0;
  }
  100% {
    opacity: 1;
    height: 300px;
    // max-height: 300px;  // 大于等于下拉菜单的高度
  }
}
.dropdown-enter-active {
  animation: expand-contract 1s;
}
.dropdown-leave-active {
  animation: expand-contract 1s reverse;
}

// 内容变化
@keyframes menu {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

// 导航栏
.nav {
  position: relative;
  display: flex;
  float: left;
  width: 67%;
  height: 80px;
  line-height: 80px;
  background-color: transparent;
  padding-left: 16%;
  color: #FFFFFF;
  //border-bottom: 1px solid #ccc;
  .nav-item {
    position: relative;
    font-size: 18px;
    margin: 0 20px;
    cursor: pointer;
    transition: all 0.3s linear;
    margin-left: 3%;
    a{
      font-size: 18px;
      color: #FFFFFF;
      &::before {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        border-bottom: #ff9d00 3px solid;
        transform: scale(0);
        transition: all 0.4s linear;
      }
      &:hover {
        color: #ff9d00;
        font-weight: bolder;
        &::before {
          transform: scale(1);
        }
      }
    }
    &::before {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      border-bottom: #ff9d00 3px solid;
      transform: scale(0);
      transition: all 0.4s linear;
    }
    &:hover {
      color: #ff9d00;
      &::before {
        transform: scale(1);
      }
    }
  }
}
.dropdown-content {
  margin: auto;
  height: 120px;
  margin-top: 80px;
  position: absolute;
  width: 100%; // 拉满
  overflow: hidden;
  z-index: 111;
  .dropdown-menu {
    height: 80px;
    padding: 15px 15px 15px;
    color: white;
    //background-color: rgba($color: #ccc, $alpha: 0.5);
    background-color: rgba(0,0,0,0.4);
    border-radius: 4px;
    margin: auto;
    text-align: center;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #000000;
    /* animation: menu 0.6s; */
      .menuItem {
        height: 80%;
        float: left;
        width: 4%;
        margin-left: 20px;
        margin-right: 20px;
        white-space: nowrap;
        padding: 10px 16px;
        font-size: 16px;
        cursor: pointer;
        transition: all 0.3s;
        border-radius: 20px;
        text-align: center;
        &:hover {
          background-color: #464D89;
          //a{
          //  .menuText{
          //    color: #ff9d00;
          //  }
          //}
        }
        a{
          .menuText {
            line-height: 30px;
            position: relative;
            font-size: 18px;
            cursor: pointer;
            font-size: 18px;
            color: #FFFFFF;
            margin: auto;
          }
          .menuImg {
            margin: auto;
            width: 40px;
            height: 40px;
            cursor: pointer;
            .img{
              background-size: cover;
              width: 100%;
              height: 100%;
            }

          }
        }
      }
   }
}
</style>



// WEBPACK FOOTER //
// src/components/navi.vue